const policyUpgrade = {
  NoOnlineUpgrade: 'NoOnlineUpgrade',
  YesNoPayment: 'YesNoPayment',
  YesPayment: 'YesPayment',
};

export default policyUpgrade;
